module.exports = __webpack_public_path__ + "img/eotg-3.81b78200.jpg";